import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import pHistoriquePaiement from '@/components/comptable/dettes/historique-paiement';
import $ from 'jquery'
import prescripteursApi from '@/api/_prescripteurs'

extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});

export default {
    name: 'dettes',
    components: {
        ValidationProvider, ValidationObserver,
        pHistoriquePaiement
    },
    props: [],
    data() {
        return {
            nature_active: 'fournisseur',
            dettes_affichees: [],
            totaux_dettes: null,
            liste_erreur: '',
            liste_requete: 0,
            recherche_timer: null,
            ignorer_prochaine_recherche: false,
            est_detruit: false,
            sync_loading: false,
            sync_message: '',
            sync_erreur: '',
            detail_prestataire: null,
            detail_fournisseur: null,
            detail_loading: false,
            detail_erreur: '',
            detail_requete: 0,
            detail_patients: {},
            detail_patients_loading: false,
            detail_patients_erreur: '',
            detail_groupes_fermes: [],
            // Base d'une ligne de rémunération redéfinie par la Trésorerie (clic sur la ligne).
            ligne_edition_id: null,
            base_saisie: '',
            base_erreur: '',
            base_message: '',
            base_enregistrement: false,
            navigation_depense: false,
            actions_dette: null,
            actions_position: {},
            actions_declencheur: null,
            actions_loading: false,
            actions_erreur: '',
            actions_payee: null,
            actions_requete: 0,
            is_empty: false,
            is_loading: true,
            solde_is_less: false,
            fields: [
                { key: 'num_facture', label: 'N° facture' }, { key: 'echeance', label: 'Echéance' },
                { key: 'ligne', label: 'Ligne budgétaire' }, 'fournisseur', 'montant', { key: 'reglement', label: 'Payé / Restant' },
                { key: 'action', label: 'Action.s' } 
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            modal_title: 'Nouvelle dette',
            dette: {
                dette_id: 0,
                ref_facture: '',
                date: '',
                montant: '',
                fournisseur: '',
                ligne_budgetaire: '',
                echeance: ''
            },
            save_loading: false,
            ligne_budget: [],

            months: [
                { id: '', lib: "Filtrer" },
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),
            curr_month: {
                id: '', lib: "Filtrer"
            },          // Current month of the year
            filter_date: '',
            is_exist: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            dette_statut: [
				{
                    libelle: 'Dette en attente',
                    id: '1',
                },
                {
                    libelle: 'Dette payée',
                    id: '2',
                }
            ],
            statut_dette: '',
            dette_type_period: '',
            dette_period: '',

            dette_a_payer: {
                dette_id: '',
                ref_facture: '',
                ligne_id: 0,
                ligne_budgetaire: '',
                montant: '',
                montant_a_payer: '',
            },
            amount_is_greater: false,
            dette_historique: {
                ligne_id: '',
                dette_id: '',
                ref_facture: '',
            },
            can_update_loading: true,

            histo_is_empty: false,
            histo_is_loading: true,
            histo_fields: [
                'date', { key: 'montant_initial', label: 'Montant initial' },
                { key: 'montant_regle', label: 'Montant réglé' }, { key: 'montant_restant', label: 'Montant restant' }
            ],
            histo_filter: "",
            dette_view: {
                id: '',
                ref_facture: '',
                libelle: ''
            },
            m_title: '',
            is_historique: false,

            // -----------------
            inputContainerEl: '',
            textInputEl: '',
            suggestionEl: '',
            svgTabIcon: '',
            svgEnterIcon: '',
        
            ENTER_KEYCODE: '',
            TAB_KEYCODE: '',
            BACKSPACE_KEYCODE: '',
            UP_ARROW_KEYCODE: '',
            DOWN_ARROW_KEYCODE: '',
        }
    },

    watch: {
        currentPage() {
            this.fermer_actions()
        },
        '$route.query'() {
            this.charger_route_dette()
        },
        'activeRole.nom'() {
            this.fermer_actions()
            this.fermer_detail_prestataire()
        },
        'userCredentials.user.id'() {
            this.fermer_actions()
            this.fermer_detail_prestataire()
        },
        filter() {
            if (this.ignorer_prochaine_recherche) {
                this.ignorer_prochaine_recherche = false
                return
            }
            this.fermer_actions()
            this.currentPage = 1
            this.totaux_dettes = null
            this.liste_requete++
            clearTimeout(this.recherche_timer)
            this.recherche_timer = setTimeout(() => {
                if (!this.est_detruit) this.getListeDettes(this.filtres_dettes())
            }, 250)
        },
        filter_date() {
            this.dette_type_period = 2
            this.dette_period = this.filter_date
            this.getListeDettes(this.filtres_dettes())
        },
        curr_month() {
            this.dette_type_period = 1
            this.dette_period = this.curr_month ? this.curr_month.id : ''
            this.getListeDettes(this.filtres_dettes())
        },
        statut_dette() {
            this.getListeDettes(this.filtres_dettes())
        }
    },

    computed: {
        mode_detail() {
            return !!(this.$route && this.$route.path === '/dettes' && this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'dette_id'))
        },
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        liste_all_ligne_budgetaire() {
            return this.$store.getters['liste_all_ligne_budgetaire']
        },

        liste_fournisseurs() {
            return this.$store.getters['liste_fournisseurs']
        },

        liste_dettes() {
            return this.dettes_affichees
        },

        dettes_visibles() {
            const recherche = this.filter.trim().toLocaleLowerCase()
            if (!recherche) return this.liste_dettes
            return this.liste_dettes.filter(dette => [dette.ref_facture, dette.date, dette.date_echeance,
                dette.libelle, dette.fournisseur, dette.beneficiaire_nom, dette.periode,
                dette.montant, dette.montant_regle, dette.montant_restant]
                .some(valeur => String(valeur == null ? '' : valeur).toLocaleLowerCase().indexOf(recherche) >= 0))
        },

        champs_dettes() {
            if (this.nature_active === 'fournisseur') return this.fields
            return [
                { key: 'num_facture', label: 'N° référence' },
                { key: 'echeance', label: 'Échéance' },
                { key: 'ligne', label: 'Ligne budgétaire' },
                { key: 'beneficiaire_nom', label: 'Médecin' },
                { key: 'periode', label: 'Période' },
                { key: 'montant', label: 'Montant dû' },
                { key: 'reglement', label: 'Payé / Restant' },
                { key: 'action', label: 'Action.s' }
            ]
        },

        dette_globale() {
            return this.dettes_visibles.reduce((total, dette) => total + Number(dette.montant || 0), 0)
        },

        titre_detail_prestataire() {
            if (this.detail_fournisseur) return 'Détails — ' + this.detail_fournisseur.ref_facture
            if (this.nature_active === 'fournisseur') return 'Détails de la dette'
            if (!this.detail_prestataire) return 'Détails de la rémunération'
            const dette = this.detail_prestataire.dette
            const periode = String(dette.periode || '')
            const mois = this.months[Number(periode.slice(5, 7))]
            const libelle_periode = /^\d{4}-(0[1-9]|1[0-2])$/.test(periode) && mois
                ? mois.lib + ' ' + periode.slice(0, 4) : periode
            return 'Rémunération — ' + dette.beneficiaire_nom + ' — ' + libelle_periode
        },

        total_detail_prestataire() {
            return this.detail_prestataire ? this.detail_prestataire.lignes.reduce((total, ligne) => total + Number(ligne.montant || 0), 0) : 0
        },

        est_detail_prestataire() {
            return !!(this.detail_prestataire && this.detail_prestataire.dette && this.detail_prestataire.dette.nature === 'prestataire')
        },

        base_saisie_valide() {
            return /^[1-9][0-9]{0,12}$/.test(String(this.base_saisie).trim())
        },

        // Part payable du détail : les anciennes réponses sans « payable » restent payables en entier.
        payable_detail_prestataire() {
            if (!this.detail_prestataire) return 0
            return this.detail_prestataire.payable !== undefined && this.detail_prestataire.payable !== null ? this.detail_prestataire.payable : this.detail_prestataire.restant
        },

        lignes_detail_prestataire() {
            if (!this.detail_prestataire) return []
            return this.detail_prestataire.lignes.map(ligne => {
                const patient = this.detail_patients[Number(ligne.clinique_entree_id)] || {}
                return Object.assign({}, ligne, { patient_nom: ligne.patient_nom || patient.patient_nom, numero_dossier: ligne.numero_dossier || patient.numero_dossier })
            })
        },

        groupes_detail_prestataire() {
            const groupes = []
            const libelles = {
                consultation: 'Consultations', analyse: 'Analyses', examen: 'Examens', acte: 'Actes',
                soin: 'Soins', soins: 'Actes', chirurgie: 'Chirurgie', medicament: 'Médicaments', non_renseigne: 'Type non renseigné'
            }
            this.lignes_detail_prestataire.forEach(ligne => {
                const type = ligne.prestation_type || 'non_renseigne'
                let groupe = groupes.find(item => item.type === type)
                if (!groupe) {
                    const libelle_type = String(type).replace(/[_-]+/g, ' ').trim()
                    const libelle = Object.prototype.hasOwnProperty.call(libelles, type) ? libelles[type]
                        : libelle_type.charAt(0).toLocaleUpperCase() + libelle_type.slice(1)
                    groupe = { type, libelle, lignes: [], montant: 0 }
                    groupes.push(groupe)
                }
                groupe.lignes.push(ligne)
                groupe.montant += Number(ligne.montant || 0)
            })
            return groupes
        },

        c_rows() {
            return this.dettes_visibles.length
        },

        dette_est_paye() {
            return this.$store.getters['dette_est_paye']
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
         monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        liste_historique_paiement_dette() {
            return this.$store.getters['liste_historique_paiement_dette']
        },

        histo_rows() {
            return this.liste_historique_paiement_dette.length
        },

        dette_montant_restant() {
            return this.$store.getters['dette_montant_restant']
        },

        solde_tresorier() {
            return this.$store.getters["solde_tresorier"];
        },

        liste_ligne_budgetaire_by_role() {
            return this.$store.getters['liste_ligne_budgetaire_by_role']
        },

        solde_restant_ligne_budgetaire() {
            return this.$store.getters['solde_restant_ligne_budgetaire']
        },
    },
    mounted() {
        if (typeof document !== 'undefined') document.addEventListener('click', this.fermer_actions_exterieur)
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.fermer_actions_exterieur)
            window.addEventListener('scroll', this.fermer_actions_exterieur, true)
        }
        $(this.$refs.detail_prestataire_modal).on('hidden.bs.modal.med003Detail', this.fermer_detail_prestataire)
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1
                this.can_view_reglement_dette = true
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3
            } else if (this.activeRole.nom == 'ROLE_TRESORERIE') {
                this.compte_id = 6
            }
        }

        // this.curr_month = this.monthOfYear[this.date.getMonth()]
        this.charger_route_dette()

        this.$store.dispatch('getListeFournisseur')

        this.$store.dispatch('getAllLigneBudgetaire')

        // this.$store.dispatch('getSoldeTresorier', this.compte_id)
    },
    beforeDestroy() {
        this.fermer_actions()
        if (typeof document !== 'undefined') document.removeEventListener('click', this.fermer_actions_exterieur)
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.fermer_actions_exterieur)
            window.removeEventListener('scroll', this.fermer_actions_exterieur, true)
        }
        clearTimeout(this.recherche_timer)
        this.est_detruit = true
        this.liste_requete++
        this.fermer_detail_prestataire()
        if (this.$refs.detail_prestataire_modal) $(this.$refs.detail_prestataire_modal).off('.med003Detail')
    },
    methods: {
        async ouvrir_actions(dette, event) {
            if (this.actions_dette && this.actions_dette.id === dette.id) return this.fermer_actions(true)
            this.fermer_actions()
            this.actions_dette = dette
            this.actions_declencheur = event.currentTarget
            const rect = event.currentTarget.getBoundingClientRect()
            const largeur = typeof window === 'undefined' ? 1024 : window.innerWidth
            const hauteur = typeof window === 'undefined' ? 768 : window.innerHeight
            this.actions_position = {
                left: Math.max(12, Math.min(rect.right - 200, largeur - 212)) + 'px',
                top: Math.max(12, rect.bottom + 222 > hauteur ? rect.top - 216 : rect.bottom + 6) + 'px'
            }
            this.$nextTick(() => {
                const premier = this.$refs.actions_menu && this.$refs.actions_menu.querySelector('button')
                if (premier) premier.focus()
            })
            if ((dette.nature || this.nature_active) !== 'fournisseur') return
            const requete = ++this.actions_requete
            this.actions_loading = true
            try {
                const payee = await this.$store.dispatch('checkIfDetteIsPaid', dette.id)
                if (requete === this.actions_requete) this.actions_payee = Number(payee)
            } catch (error) {
                if (requete === this.actions_requete) this.actions_erreur = 'Actions de paiement indisponibles.'
            } finally {
                if (requete === this.actions_requete) this.actions_loading = false
            }
        },

        fermer_actions(rendre_focus = false) {
            if (rendre_focus && this.actions_declencheur) this.actions_declencheur.focus()
            this.actions_requete++
            this.actions_dette = null
            this.actions_declencheur = null
            this.actions_payee = null
            this.actions_erreur = ''
            this.actions_loading = false
        },

        fermer_actions_exterieur(event) {
            if (this.$refs.actions_menu && this.$refs.actions_menu.contains(event.target)) return
            this.fermer_actions()
        },

        clavier_actions(event) {
            if (event.key === 'Escape') {
                event.preventDefault()
                this.fermer_actions(true)
            } else if (event.key === 'Tab') this.fermer_actions()
            else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault()
                const boutons = Array.from(this.$refs.actions_menu.querySelectorAll('button:not([disabled])'))
                const index = boutons.indexOf(event.target)
                if (boutons.length) boutons[(index + (event.key === 'ArrowDown' ? 1 : boutons.length - 1)) % boutons.length].focus()
            }
        },

        executer_action_dette(action) {
            const dette = this.actions_dette
            if (!dette) return
            this.fermer_actions()
            if (action === 'details') return this.ouvrir_details(dette)
            if (action === 'payer' && dette.nature === 'prestataire') return this.dettePaie(dette)
            if (action === 'historique') this.viewHistoriquePaiement(dette)
            if (action === 'payer') this.dettePaie(dette)
            if (action === 'supprimer') this.remove(dette)
            $(action === 'supprimer' ? this.$refs.del_dette : this.$refs.close_pay).modal('show')
        },

        attributs_ligne_dette(dette) {
            return dette ? { 'aria-label': 'Détails de la dette ' + dette.ref_facture } : {}
        },
        async charger_route_dette() {
            this.fermer_actions()
            this.fermer_detail_prestataire()
            clearTimeout(this.recherche_timer)
            this.liste_requete++
            if (this.$route && this.$route.path && this.$route.path !== '/dettes') return
            const query = this.$route && this.$route.query || {}
            if (['fournisseur', 'prestataire', 'prescripteur'].indexOf(query.nature) >= 0) this.nature_active = query.nature
            if (!this.mode_detail) return this.getListeDettes(this.filtres_dettes())
            // Old deep links now open a popup while keeping the list underneath.
            this.getListeDettes(this.filtres_dettes())
            this.afficher_popup_details()
            const id = Number(query.dette_id)
            if (typeof query.dette_id !== 'string' || !/^[1-9]\d*$/.test(query.dette_id) || !Number.isSafeInteger(id)
                || ['fournisseur', 'prestataire', 'prescripteur'].indexOf(query.nature) < 0) {
                this.detail_erreur = 'Cette adresse de détails est invalide.'
                return
            }
            return this.charger_details_dette({ id, nature: query.nature })
        },

        async charger_details_dette(dette) {
            if (['prestataire', 'prescripteur'].includes(dette.nature)) return this.voir_detail_prestataire(dette)
            const id = Number(dette.id)
            const requete = ++this.detail_requete
            this.detail_loading = true
            try {
                const response = await this.$store.dispatch('getListeDette', { nature: 'fournisseur', statut: '', type_period: '', period: '', recherche: '', avec_totaux: true })
                if (this.est_detruit || requete !== this.detail_requete) return
                const dettes = Array.isArray(response) ? response : response && response.dettes
                const dette = Array.isArray(dettes) && dettes.find(item => Number(item.id) === id && (!item.nature || item.nature === 'fournisseur'))
                if (!dette) throw new Error('Dette indisponible')
                this.detail_fournisseur = dette
            } catch (error) {
                if (!this.est_detruit && requete === this.detail_requete) this.detail_erreur = 'Cette dette est introuvable ou ses détails ne sont pas accessibles.'
            } finally {
                if (!this.est_detruit && requete === this.detail_requete) this.detail_loading = false
            }
        },

        async ouvrir_details(dette) {
            const id = Number(dette && dette.id)
            const nature = dette && dette.nature || this.nature_active
            if (!Number.isSafeInteger(id) || id <= 0 || ['fournisseur', 'prestataire', 'prescripteur'].indexOf(nature) < 0) return
            this.fermer_actions()
            this.fermer_detail_prestataire()
            this.afficher_popup_details()
            return this.charger_details_dette({ id, nature })
        },

        afficher_popup_details() {
            if (this.$refs.detail_prestataire_modal) $(this.$refs.detail_prestataire_modal).modal('show')
        },

        filtres_dettes() {
            return { statut: this.statut_dette && this.statut_dette.id || this.statut_dette || '', type_period: this.dette_type_period, period: this.dette_period }
        },

        async changer_nature(nature) {
            if (['fournisseur', 'prestataire', 'prescripteur'].indexOf(nature) < 0 || nature === this.nature_active) return
            this.fermer_detail_prestataire()
            this.fermer_actions()
            this.nature_active = nature
            this.liste_requete++
            this.currentPage = 1
            this.ignorer_prochaine_recherche = this.filter !== ''
            this.filter = ''
            this.dettes_affichees = []
            this.is_loading = true
            if (nature === 'prestataire') await this.synchroniser_remunerations()
            else await this.getListeDettes(this.filtres_dettes())
        },

        async synchroniser_remunerations() {
            if (this.sync_loading || this.nature_active !== 'prestataire') return
            this.sync_loading = true
            this.sync_message = ''
            this.sync_erreur = ''
            try {
                const access = await this.$store.dispatch('getTresorerieRemunerationAccess')
                this.verifier_reponse_sync(access && access.success === true && access.data && typeof access.data.access_token === 'string' && access.data.access_token)
                const access_token = access.data.access_token
                const v1 = await this.synchroniser_lot_remunerations({
                    lecture: 'getRemunerationsEnAttente', import: 'importerDettesPrestataires', confirmation: 'updateStatutRemunerations'
                }, access_token)
                // V2 is an explicit, source-aware channel. It is fetched only
                // after V1 has completed so a legacy transfer is never
                // reinterpreted as a newer clinical event.
                const v2 = await this.synchroniser_lot_remunerations({
                    lecture: 'getRemunerationsEnAttenteV2', import: 'importerDettesPrestatairesV2', confirmation: 'updateStatutRemunerationsV2'
                }, access_token)
                // Clôtures de consultation : les lignes déjà importées deviennent payables.
                const payables = await this.synchroniser_clotures(access_token)
                const synchronisees = v1.exportees + v2.exportees
                const restantes = v1.restantes + v2.restantes
                this.sync_message = synchronisees > 0 ? synchronisees + ' rémunération(s) synchronisée(s).'
                    : 'Aucune rémunération en attente.'
                if (payables > 0) this.sync_message += ' ' + payables + ' ligne(s) devenue(s) payable(s) après la clôture de la consultation.'
                if (restantes > 0) this.sync_message += ' ' + restantes + ' encore en attente : cliquez sur Synchroniser pour continuer.'
            } catch (error) {
                this.sync_erreur = this.erreur_synchronisation(error, error && error.med003_phase || 'acces')
            } finally {
                if (!this.est_detruit) await this.getListeDettes(this.filtres_dettes())
                this.sync_loading = false
            }
        },

        async synchroniser_lot_remunerations(actions, access_token) {
            let phase = 'lecture'
            try {
                const attente = await this.$store.dispatch(actions.lecture, access_token)
                this.verifier_reponse_sync(attente && Array.isArray(attente.entrees) && Number.isInteger(attente.total) && attente.total >= attente.entrees.length)
                if (attente.entrees.length === 0) return { exportees: 0, restantes: attente.total }

                this.verifier_reponse_sync(typeof attente.transfert === 'string' && attente.transfert)
                phase = 'import'
                const resultat = await this.$store.dispatch(actions.import, { transfert: attente.transfert, access_token })
                this.verifier_reponse_sync(resultat && resultat.success === true && typeof resultat.recu_import === 'string' && resultat.recu_import)
                phase = 'confirmation'
                const confirmation = await this.$store.dispatch(actions.confirmation, { recu_import: resultat.recu_import, access_token })
                this.verifier_reponse_sync(confirmation && confirmation.success === true && confirmation.exportees === attente.entrees.length)
                return { exportees: confirmation.exportees, restantes: attente.total - attente.entrees.length }
            } catch (error) {
                const erreur = error && typeof error === 'object' ? error : new Error('Synchronisation indisponible.')
                erreur.med003_phase = phase
                throw erreur
            }
        },

        async synchroniser_clotures(access_token) {
            let phase = 'lecture'
            try {
                const attente = await this.$store.dispatch('getCloturesEnAttente', access_token)
                this.verifier_reponse_sync(attente && Array.isArray(attente.clotures) && Number.isInteger(attente.total))
                if (attente.clotures.length === 0) return 0
                this.verifier_reponse_sync(typeof attente.transfert === 'string' && attente.transfert)
                phase = 'import'
                const resultat = await this.$store.dispatch('appliquerCloturesPrestataires', { transfert: attente.transfert, access_token })
                this.verifier_reponse_sync(resultat && resultat.success === true && typeof resultat.recu_cloture === 'string' && resultat.recu_cloture)
                phase = 'confirmation'
                const confirmation = await this.$store.dispatch('updateCloturesTransmises', { recu_cloture: resultat.recu_cloture, access_token })
                this.verifier_reponse_sync(confirmation && confirmation.success === true)
                return Number(resultat.appliquees) || 0
            } catch (error) {
                const erreur = error && typeof error === 'object' ? error : new Error('Synchronisation indisponible.')
                erreur.med003_phase = phase
                throw erreur
            }
        },

        verifier_reponse_sync(valide) {
            if (!valide) {
                const error = new Error('Réponse de synchronisation incomplète.')
                error.med003_reponse = true
                throw error
            }
        },

        erreur_synchronisation(error, phase) {
            const status = error && error.response ? error.response.status : 0
            const service = phase === 'acces' ? 'Authentification' : (phase === 'import' ? 'Caisse' : 'Clinique')
            const etape = phase === 'confirmation' ? 'Confirmation Clinique' : service
            if (error && error.med003_reponse) return etape + ' : réponse de synchronisation incomplète. Réessayez.'
            if (status === 401) return phase === 'acces'
                ? 'Session non authentifiable. Reconnectez-vous avant de synchroniser.'
                : etape + ' : accès expiré ou invalide. Relancez la synchronisation.'
            if (status === 403) return etape + ' : accès non autorisé pour ce compte Trésorerie.'
            if (status === 503) return etape + ' : service ou échange non configuré. Contactez votre administrateur.'
            if (status === 409) return etape + ' : conflit de données. Les rémunérations restent à vérifier.'
            if (status === 422) return etape + ' : données de synchronisation refusées. Contactez votre administrateur.'
            return etape + ' indisponible. Réessayez ; les imports déjà effectués seront reconnus.'
        },

        async getListeDettes(data) {
            this.fermer_actions()
            clearTimeout(this.recherche_timer)
            const requete = ++this.liste_requete
            const nature = this.nature_active
            this.currentPage = 1
            this.is_loading = true
            this.liste_erreur = ''
            this.dettes_affichees = []
            this.totaux_dettes = null
            this.is_empty = true
            try {
                const response = await this.$store.dispatch('getListeDette',
                    Object.assign({}, this.filtres_dettes(), data || {}, { nature, recherche: this.filter.trim(), avec_totaux: true }))
                if (this.est_detruit || requete !== this.liste_requete || nature !== this.nature_active) return
                this.dettes_affichees = Array.isArray(response) ? response : response && Array.isArray(response.dettes) ? response.dettes : []
                const totaux = response && response.totaux
                if (totaux && ['nombre', 'du', 'paye', 'restant'].every(cle => totaux[cle] !== null && Number.isFinite(Number(totaux[cle])))) this.totaux_dettes = totaux
                this.is_empty = this.dettes_affichees.length === 0
            } catch (error) {
                if (!this.est_detruit && requete === this.liste_requete) this.liste_erreur = 'Impossible de charger les dettes. Réessayez.'
            } finally {
                if (!this.est_detruit && requete === this.liste_requete) this.is_loading = false
            }
        },

        async voir_detail_prestataire(dette) {
            if (!['prestataire', 'prescripteur'].includes(dette.nature)) return
            const requete = ++this.detail_requete
            this.detail_prestataire = null
            this.detail_erreur = ''
            this.detail_loading = true
            this.detail_patients = {}
            this.detail_patients_erreur = ''
            this.detail_patients_loading = false
            this.detail_groupes_fermes = []
            try {
                let detail
                if (dette.nature === 'prescripteur') {
                    const access = await this.$store.dispatch('getTresorerieRemunerationAccess')
                    this.verifier_reponse_sync(access && access.success === true && access.data && access.data.access_token)
                    detail = await prescripteursApi.detail(dette.id, access.data.access_token)
                } else detail = await this.$store.dispatch('getDetailDettePrestataire', { dette_id: dette.id })
                if (this.est_detruit || requete !== this.detail_requete) return
                if (!detail || !detail.dette || !Array.isArray(detail.lignes)
                    || Number(detail.dette.id) !== Number(dette.id) || detail.dette.nature !== dette.nature) throw new Error('Détail incomplet')
                this.detail_prestataire = detail
                this.detail_loading = false
                if (dette.nature === 'prestataire') await this.charger_patients_remunerations(detail, requete)
            } catch (error) {
                if (!this.est_detruit && requete === this.detail_requete) {
                    const status = error && error.response ? error.response.status : 0
                    this.detail_erreur = status === 403 ? 'Vous n’êtes pas autorisé à consulter ce détail.'
                        : 'Impossible de charger le détail. Fermez puis réessayez.'
                }
            } finally {
                if (!this.est_detruit && requete === this.detail_requete) this.detail_loading = false
            }
        },

        async charger_patients_remunerations(detail, requete) {
            const entree_ids = Array.from(new Set(detail.lignes.map(ligne => Number(ligne.clinique_entree_id))
                .filter(id => Number.isSafeInteger(id) && id > 0)))
            if (!entree_ids.length) return
            this.detail_patients_loading = true
            try {
                const access = await this.$store.dispatch('getTresorerieRemunerationAccess')
                if (this.est_detruit || requete !== this.detail_requete) return
                this.verifier_reponse_sync(access && access.success === true && access.data && typeof access.data.access_token === 'string' && access.data.access_token)
                const access_token = access.data.access_token
                const patients = {}
                for (let debut = 0; debut < entree_ids.length; debut += 500) {
                    const lot = entree_ids.slice(debut, debut + 500)
                    const response = await this.$store.dispatch('getPatientsRemunerations', { entree_ids: lot, access_token })
                    if (this.est_detruit || requete !== this.detail_requete) return
                    if (!response || !Array.isArray(response.patients)) throw new Error('Identités incomplètes')
                    response.patients.forEach(patient => {
                        if (patient && lot.indexOf(Number(patient.entree_id)) >= 0) patients[Number(patient.entree_id)] = {
                            patient_nom: patient.patient_nom, numero_dossier: patient.numero_dossier
                        }
                    })
                }
                this.detail_patients = patients
            } catch (error) {
                if (!this.est_detruit && requete === this.detail_requete) {
                    this.detail_patients_erreur = 'Identités des patients indisponibles. Les montants restent consultables. Fermez puis réessayez.'
                }
            } finally {
                if (!this.est_detruit && requete === this.detail_requete) this.detail_patients_loading = false
            }
        },

        // Colonne « Règle » (tableau retenu pour la rémunération du médecin) : mode, valeur et base en une phrase
        // courte. Un forfait n'est jamais présenté comme un taux nul ; la quantité n'apparaît que si elle dépasse 1.
        // Prestataire (21/10/2026) : « 30% de M », M étant la base d'un acte, par défaut ou redéfinie.
        regle_remuneration(ligne) {
            const devise = this.currency_info && this.currency_info.principal_currency ? ' ' + this.currency_info.principal_currency : ''
            const quantite = Number(ligne && ligne.quantite)
            const fois = quantite > 1 ? ' × ' + this.formatNumberCompact(quantite) : ''
            if (ligne && ligne.mode_remuneration === 'montant_fixe') return 'Forfait fixe de ' + this.formatCurrency(ligne.montant_fixe) + devise + fois
            if (this.est_detail_prestataire) {
                const base_unitaire = this.ligne_edition_id === ligne.id && this.base_saisie_valide ? Number(this.base_saisie) : this.base_unitaire(ligne)
                return this.formatNumberCompact(ligne.pourcentage != null ? ligne.pourcentage : 0) + '% de ' + this.formatCurrency(base_unitaire) + fois
            }
            const taux = this.formatNumberCompact(ligne && ligne.pourcentage != null ? ligne.pourcentage : 0) + ' %'
            const base = ligne && ligne.base_remuneration != null && ligne.base_remuneration !== '' ? ligne.base_remuneration
                : ligne && ligne.prix_unitaire != null && ligne.prix_unitaire !== '' ? ligne.prix_unitaire : null
            return base === null ? taux + ' du P.U.' + fois : taux + ' de ' + this.formatCurrency(base) + devise + fois
        },

        // Base d'un acte (M). Sans base transmise, le P.U. de l'acte, comme l'ancienne colonne Règle.
        base_unitaire(ligne) {
            const totale = ligne.base_remuneration != null && ligne.base_remuneration !== '' ? ligne.base_remuneration : ligne.prix_unitaire
            return Math.round(Number(totale || 0) / Math.max(1, Number(ligne.quantite) || 1))
        },

        // Montant affiché : recalculé en direct pendant la saisie d'une base.
        montant_ligne(ligne) {
            if (this.ligne_edition_id !== ligne.id || !this.base_saisie_valide) return Number(ligne.montant || 0)
            return Math.round(Number(this.base_saisie) * Math.max(1, Number(ligne.quantite) || 1) * Number(ligne.pourcentage || 0) / 100)
        },

        libelle_base(ligne) {
            const defaut = Math.round(Number(ligne.base_defaut || 0) / Math.max(1, Number(ligne.quantite) || 1))
            if (ligne.base_modifiee_le) return 'Modifiée · par défaut ' + this.formatCurrency(defaut)
            const assurance = ligne.assurance_nom ? ' ' + ligne.assurance_nom : ''
            const sources = {
                base_assurance: 'Base assurance' + assurance, prix_non_assure: 'Prix non assuré', contrat_expire: 'Contrat' + assurance + ' expiré : prix non assuré',
                prestation_exclue: 'Exclue de la couverture' + assurance + ' : prix non assuré', base_absente: 'Sans base' + assurance + ' : prix non assuré',
                regle: 'Base saisie dans la règle'
            }
            const libelle = sources[ligne.base_source] || ''
            const ajustement = Number(ligne.ajustement_base)
            return libelle && ajustement > 0 && ajustement < 100 ? libelle + ' · ' + this.formatNumberCompact(ajustement) + ' %' : libelle
        },

        ligne_cliquee(ligne) {
            if (!this.est_detail_prestataire || this.base_enregistrement || this.ligne_edition_id === ligne.id) return
            this.base_message = ''
            if (ligne.mode_remuneration === 'montant_fixe') { this.base_message = 'Forfait fixe : il n’y a pas de base à redéfinir.'; return }
            if (!this.activeRole || this.activeRole.nom !== 'ROLE_TRESORERIE') { this.base_message = 'Seule la Trésorerie peut redéfinir une base.'; return }
            if (!this.detail_prestataire.base_modifiable) { this.base_message = 'Cette dette a déjà reçu un règlement : les bases sont verrouillées.'; return }
            this.ligne_edition_id = ligne.id
            this.base_saisie = String(this.base_unitaire(ligne))
            this.base_erreur = ''
            this.$nextTick(() => {
                const champ = this.$refs['base_ligne_' + ligne.id]
                const element = Array.isArray(champ) ? champ[0] : champ
                if (element) { element.focus(); element.select() }
            })
        },

        annuler_base() {
            this.ligne_edition_id = null
            this.base_saisie = ''
            this.base_erreur = ''
        },

        async enregistrer_base(ligne) {
            if (this.ligne_edition_id !== ligne.id || this.base_enregistrement) return
            if (!this.base_saisie_valide) { this.base_erreur = 'Saisissez un montant entier supérieur à 0.'; return }
            const base = Number(this.base_saisie)
            if (base === this.base_unitaire(ligne)) { this.annuler_base(); return }
            this.base_enregistrement = true
            this.base_erreur = ''
            const requete = this.detail_requete
            try {
                const access = await this.$store.dispatch('getTresorerieRemunerationAccess')
                this.verifier_reponse_sync(access && access.success === true && access.data && typeof access.data.access_token === 'string' && access.data.access_token)
                const reponse = await this.$store.dispatch('modifierBaseRemuneration', {
                    ligne_id: ligne.id, base, access_token: access.data.access_token,
                    user_nom: this.userCredentials && this.userCredentials.user ? this.userCredentials.user.name : null
                })
                if (this.est_detruit || requete !== this.detail_requete || !this.detail_prestataire) return
                this.verifier_reponse_sync(reponse && reponse.success === true && reponse.ligne && Number(reponse.ligne.id) === Number(ligne.id))
                this.appliquer_ligne_modifiee(reponse.ligne)
                this.base_message = ligne.prestation_libelle + ' : ' + this.regle_remuneration(reponse.ligne) + ' = ' + this.formatCurrency(reponse.ligne.montant) + ' ' + (this.currency_info.principal_currency || '') + '.'
                this.annuler_base()
                this.getListeDettes(this.filtres_dettes())
            } catch (error) {
                if (this.est_detruit || requete !== this.detail_requete) return
                const data = error && error.response && error.response.data
                this.base_erreur = data && data.message ? data.message : 'Impossible d’enregistrer la base. Réessayez.'
            } finally {
                if (!this.est_detruit) this.base_enregistrement = false
            }
        },

        appliquer_ligne_modifiee(ligne) {
            const detail = this.detail_prestataire
            const lignes = detail.lignes.map(item => Number(item.id) === Number(ligne.id) ? Object.assign({}, item, ligne) : item)
            const du = lignes.reduce((total, item) => total + Number(item.montant || 0), 0)
            const attente = lignes.filter(item => item.est_payable === false).reduce((total, item) => total + Number(item.montant || 0), 0)
            const restant = du - Number(detail.paye || 0)
            this.detail_prestataire = Object.assign({}, detail, { lignes, du, restant, en_attente_cloture: attente, payable: Math.max(0, restant - attente) })
        },

        libelle_nombre_prestations(nombre) {
            return nombre + (nombre > 1 ? ' prestations' : ' prestation')
        },

        basculer_groupe_prestataire(type) {
            const index = this.detail_groupes_fermes.indexOf(type)
            if (index < 0) this.detail_groupes_fermes.push(type)
            else this.detail_groupes_fermes.splice(index, 1)
        },

        fermer_detail_prestataire() {
            this.detail_requete++
            this.detail_prestataire = null
            this.detail_fournisseur = null
            this.detail_patients = {}
            this.detail_patients_erreur = ''
            this.detail_patients_loading = false
            this.detail_loading = false
            this.detail_erreur = ''
            this.detail_groupes_fermes = []
            this.annuler_base()
            this.base_message = ''
        },

        // Seule la part des consultations clôturées est payable (montant_payable / payable du détail).
        peut_payer_prestataire(dette, montant_restant) {
            const payable = dette && dette.montant_payable !== undefined && dette.montant_payable !== null ? dette.montant_payable : dette && dette.montant_restant
            const restant = montant_restant === undefined ? payable : montant_restant
            return !!(dette && dette.nature === 'prestataire' && this.activeRole && this.activeRole.nom === 'ROLE_TRESORERIE'
                && Number.isSafeInteger(Number(dette.id)) && Number(dette.id) > 0 && Number.isFinite(Number(restant)) && Number(restant) > 0)
        },

        async ouvrir_depense_prestataire(dette, montant_restant) {
            if (this.navigation_depense || !this.peut_payer_prestataire(dette, montant_restant)) return
            this.navigation_depense = true
            try {
                const modales = [this.$refs.detail_prestataire_modal, this.$refs.close_pay]
                    .filter(element => element && ($(element).hasClass('show') || $(element).is(':visible')))
                await Promise.all(modales.map(element => new Promise(resolve => {
                    const modale = $(element)
                    const terminer = () => {
                        modale.off('.med003Depense')
                        this.$off('hook:beforeDestroy', terminer)
                        resolve()
                    }
                    this.$once('hook:beforeDestroy', terminer)
                    modale.one('hidden.bs.modal.med003Depense', terminer)
                    modale.one('shown.bs.modal.med003Depense', () => modale.modal('hide'))
                    modale.modal('hide')
                })))
                if (!this.est_detruit && this.peut_payer_prestataire(dette, montant_restant)) {
                    await this.$router.push({ path: '/depenses', query: { dette_id: String(dette.id) } })
                }
            } catch (error) {
                if (!this.est_detruit && (!error || error.name !== 'NavigationDuplicated')) this.warningToast('Impossible d’ouvrir la page Dépenses. Réessayez.')
            } finally {
                if (!this.est_detruit) this.navigation_depense = false
            }
        },

        getListeHistorique(data) {
            this.histo_is_loading = true
            this.$store.dispatch('getListeHistoriqueDette', data).then(() => {
                if (this.liste_historique_paiement_dette.length > 0) {
                    this.histo_is_empty = false
                } else {
                    this.histo_is_empty = true
                }

                this.histo_is_loading = false
            })
        },

        clearError() {
            this.is_exist = false

            this.amount_is_greater = false
            this.solde_is_less = false
        },

        async save() {
            if (this.nature_active !== 'fournisseur') return
            const isValid = await this.$refs.dette_form.validate();
            if (!isValid) {
                return;
            }
            this.save_loading = true

            var data = {
                dette_id: this.dette.dette_id,
                ref_facture: this.dette.ref_facture,
                date: this.dette.date,
                montant: this.dette.montant,
                fournisseur: this.dette.fournisseur,
                ligne_budgetaire: this.dette.ligne_budgetaire.id,
                echeance: this.dette.echeance
            }

            this.$store.dispatch('saveDette', data).then((response) => {
                if (response > 0) {
                    this.successToast("Dette ajoutée avec succès")

                    this.dette = {
                        dette_id: '',
                        ref_facture: '',
                        date: '',
                        montant: '',
                        fournisseur: '',
                        ligne_budgetaire: '',
                        echeance: ''
                    }
                    this.$refs.dette_form.reset()
                    this.$refs.add_dette.click()

                    this.getListeDettes(this.filtres_dettes())
                } else {
                    this.is_exist = true
                }

                this.save_loading = false
            })
        },

        newDette() {
            if (this.nature_active !== 'fournisseur') return
            this.dette = {
                dette_id: 0,
                ref_facture: '',
                date: '',
                montant: '',
                fournisseur: '',
                ligne_budgetaire: '',
                echeance: ''
            }
            this.$refs.dette_form.reset()
        },

        edit(data) {
            if (this.nature_active !== 'fournisseur' || (data.nature && data.nature !== 'fournisseur')) return
            this.dette = {
                dette_id: data.id,
                ref_facture: data.ref_facture,
                date: data.date,
                montant: data.montant,
                fournisseur: data.fournisseur,
                ligne_budgetaire: {
                    id: data.ligne_id,
                    libelle: data.libelle
                },
                echeance: data.date_echeance
            }

            this.modal_title = 'Modifier dette'
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        /**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
            if (this.nature_active !== 'fournisseur' || (data.nature && data.nature !== 'fournisseur')) return
			this.to_be_deleted = {
                id: data.id,
                libelle: data.ref_facture
            }
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            if (this.nature_active !== 'fournisseur') return
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé 
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('removeDette', this.to_be_deleted).then((response) => {
                    if (response > 0) {
                        this.successToast('Dette supprimée avec succès')
                    }
                    this.del_loading = false;
                    this.is_confirm = false

                    this.getListeDettes(this.filtres_dettes())
					this.$refs.del_dette.click()
                })
            }
        },

        dettePaie(data) {
            if (data.nature === 'prestataire') return this.ouvrir_depense_prestataire(data)
            this.clearError()
            this.m_title = 'Paiement de dette'
            this.is_historique = false
            this.dette_a_payer = {
                dette_id: data.id,
                ref_facture: data.ref_facture,
                ligne_id: data.ligne_id,
                ligne_budgetaire: data.libelle,
                montant_du: data.nature === 'prestataire' ? Number(data.montant_restant || 0) : data.montant,
                montant_a_payer: '',
            }

            this.dette_view =  {
                id: data.id,
                ref_facture: data.ref_facture,
                libelle: data.libelle
            }
            $('.histo').fadeOut(500)
            setTimeout(() => {
                $('.is-paiement').fadeIn()
            }, 500);
            
            const params = {
                month: (this.date.getMonth()+1),       // mois courant
                role_id: 14,
                ligne_id: data.ligne_id
            }
            this.$store.dispatch('getSoldeCourantLigneBudgetaire', params)
        },

        async payer() {
            const isValid = await this.$refs.reglement_form.validate();
            if (!isValid) {
                return;
            }

            if (this.dette_a_payer.montant_a_payer > this.dette_a_payer.montant_du) {
                this.amount_is_greater = true
                return;
            }

            // Verifier le solde disponible pour regler la dette
            if (this.solde_restant_ligne_budgetaire.solde_restant < this.dette_a_payer.montant_a_payer) {
                this.solde_is_less = true
                return;
            }

            this.save_loading = true

            var commentaire = ''
            if ( (this.dette_a_payer.montant_du - this.dette_a_payer.montant_a_payer) == 0 ) {
                commentaire = 'Solde de la facture '+this.dette_a_payer.ref_facture
            } else {
                commentaire = 'Acompte de la facture '+this.dette_a_payer.ref_facture
            }

            var data = {
                data_type: "reglement_dette",
                type_operation: 2,
                source: this.compte_id,
                user_id: this.userCredentials.user.id,
                dette_id: this.dette_a_payer.dette_id,
                ref_facture: this.dette_a_payer.ref_facture,
                ligne_budgetaire: this.dette_a_payer.ligne_budgetaire,
                ligne_budgetaire_id: this.dette_a_payer.ligne_id,
                montant_du: this.dette_a_payer.montant_du,
                montant_a_payer: parseInt(this.dette_a_payer.montant_a_payer),
                commentaire: commentaire
            }

            this.$store.dispatch('saveReglementDette', data).then((response) => {
                if (response.success) {
                    this.successToast("Dette réglée avec succès")

                    this.$refs.reglement_form.reset()
                    this.$refs.close_pay.click()
                    this.getListeDettes(this.filtres_dettes())
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        },

        checkDettePaiement(dette_id) {
            this.can_update_loading = true
            this.$store.dispatch('checkIfDetteIsPaid', dette_id).then(() => {
                this.can_update_loading = false
            })
        },

        viewHistoriquePaiement(data) {
            this.m_title = 'Historique de paiement'
            this.is_historique = true

            this.dette_historique = {
                nature: data.nature,
                ligne_id: data.ligne_id,
                dette_id: data.id,
                ref_facture: data.ref_facture,
                ligne_budgetaire: data.libelle,
            }

            this.dette_view = data

            var q_data = {
                dette_id: data.id,
                type_period: 2,
                period: data.date
            }
            // var q_data = {
            //     dette_id: data.id,
            //     type_period: this.dette_type_period,
            //     period: this.dette_period
            // }
            this.getListeHistorique(q_data)

            this.getDetteMontantRestant(data.id)

            
            $('.is-paiement').fadeOut(500)
            setTimeout(() => {
                $('.histo').fadeIn()
            }, 500);
        },

        goToHistorique(data) {
            this.m_title = 'Historique de paiement'
            this.is_historique = true

            this.dette_historique = {
                nature: data.nature,
                ligne_id: data.ligne_id,
                dette_id: data.id,
                ref_facture: data.ref_facture,
                ligne_budgetaire: data.libelle,
            }

            var q_data = {
                dette_id: data.id,
                type_period: 2,
                period: data.date
            }
            this.getListeHistorique(q_data)

            this.getDetteMontantRestant(data.id)

            
            $('.is-paiement').fadeOut(500)
            setTimeout(() => {
                $('.histo').fadeIn()
            }, 500);
        },

        getDetteMontantRestant(dette_id) {
            this.$store.dispatch('getDetteMontantRestant', dette_id)
        },

        reglerDette(data, montant_initial) {
            if (data.nature === 'prestataire') return this.ouvrir_depense_prestataire(Object.assign({}, data, { id: data.dette_id }), montant_initial)
            this.m_title = 'Paiement de dette'
            this.is_historique = false
            this.dette_a_payer = {
                dette_id: data.dette_id,
                ref_facture: data.ref_facture,
                ligne_budgetaire: data.ligne_budgetaire,
                ligne_id: data.ligne_id,
                montant_du: montant_initial,
                montant_a_payer: '',
            }

            $('.histo').fadeOut(500)
            setTimeout(() => {
                $('.is-paiement').fadeIn()
            }, 500);

            const params = {
                month: (this.date.getMonth()+1),       // mois courant
                role_id: 14,
                ligne_id: data.ligne_id
            }
            this.$store.dispatch('getSoldeCourantLigneBudgetaire', params)
        },

        removeClassAfterAnimationCompletes(el, className) {
            let elStyles = window.getComputedStyle(this.inputContainerEl);
            setTimeout(function() {
                el.classList.remove(className);
            }, +elStyles.animationDuration.replace("s", "") * 1000);
        },
    
        filterArray(array, item, reverse = false) {
            if (reverse) {
                return array
                    .filter(word => this.compareTwoStrings(word, item))
                    .sort((a, b) => a.length - b.length);
            } else {
                return array
                    .filter(word => this.compareTwoStrings(word, item))
                    .sort((a, b) => b.length - a.length);
            }
        },
    
        removeDuplicatesFromArray(array) {
            return [...new Set(array.map(i => i))];
        },
    
        compareTwoStrings(string, subString) {
            let temp = string.split("", subString.length).join("");
            if (subString == temp) return subString;
        },
    }
}


